<template>
	<div v-if="data" @click="select">
		<p class="font-bold mb-2" v-if="data.ttsessiontype_name">{{ data.ttsessiontype_name }}</p>
		<p class="mb-0" v-if="children > 0">
			<b-icon icon="check-circle-fill" variant="success" /> Assist
		</p>
	</div>
</template>

<script>
export default {
	props: ["data", "swipedLeftItem"],
	data: function () {
		return {
			children: 0,
			loaded: false,
		};
	},
	mounted() {
		this.getChildren();
	},
	methods: {
		select: function () {
			if (this.data) {
				this.$emit("selectItem", this.data.id);
			}
		},
		getChildren: function () {
			// if (this.data && this.data.id) {
			// 	fetch(`http://localhost:3000/sessionTypes?sessiontypeparent_id=${this.data.id}`)
			// 		.then(res => res.json())
			// 		.then(json => {
			// 			console.log('json111', json);
			// 			if (json.status === "SUCCESS") {
			// 				console.log('json111', json);
			// 				this.children = json.data.length;
			// 				this.loaded = true;
			// 			}
			// 		})
			// 		.catch(err => console.error(err));
			// }
		},
	},
};
</script>
